export default {  

    end: "Il tuo profilo in Farmer 4.0 ",

    profile: "IL TUO PROFILO",

    restart: "Ricomincia da capo il percorso di valutazione e orientamento",

    submit: "Invia",

    print: "Download il tuo profilo in PDF",

    data: "TUOI DATI",

    progress: "Avanzamento",

    confirm: {

        restart: 'Sei sicuro di voler ricominciare il test e PERDERE TUTTE INFORMAZIONI INSERITE?'

    },

    steps: {

        "0-1": "VALUTAZIONE DEL LIVELLO DI ISTRUZIONE",

        "0-2": "ESPERIENZA IMPRENDITORIALE IN AGRICOLTURA",

        "1-1": "IDENTIFICAZIONE DELLE PASSATE ESPERIENZE IN AGRICOLTURA",

        "1-2": "IDENTIFICAZIONE DELLE PASSATE ESPERIENZE IN AGRICOLTURA",

        "1-3": "IDENTIFICAZIONE DELLE PASSATE ESPERIENZE IN AGRICOLTURA",

        "1-4": "IDENTIFICAZIONE DELLE PASSATE ESPERIENZE IN AGRICOLTURA",

        "2": "PROPENSIONE ALL'IMPRENDITORIALITÀ",

        "3-1": "COMPETENZE TRASVERSALI PER ESSERE UN IMPRENDITORE DI SUCCESSO – CREATIVITA’",

        "3-2": "COMPETENZE TRASVERSALI PER ESSERE UN IMPRENDITORE DI SUCCESSO – COMUNICAZIONE PARTE 1",

        "3-3": "COMPETENZE TRASVERSALI PER ESSERE UN IMPRENDITORE DI SUCCESSO – COMUNICAZIONE PARTE 2",

        "3-4": "COMPETENZE TRASVERSALI PER ESSERE UN IMPRENDITORE DI SUCCESSO – COMUNICAZIONE PARTE 3",

        "3-5": "COMPETENZE TRASVERSALI PER ESSERE UN IMPRENDITORE DI SUCCESSO – COMUNICAZIONE PARTE 4",

        "4-1": "ICOMPETENZE INFORMATICHE – COMPETENZE CHIAVE",

        "4-2-1": "COMPETENZE TIC PER FARMER 4.0",

        "4-2-2": "COMPETENZE TIC PER FARMER 4.0",

        "4-2-3": "COMPETENZE TIC PER FARMER 4.0",

        "4-2-4": "COMPETENZE TIC PER FARMER 4.0",

        "4-2-5": "COMPETENZE TIC PER FARMER 4.0",

        "4-2-6": "COMPETENZE TIC PER FARMER 4.0",

        "5-1": "ALTRE COMPETENZE PROFESSIONALI PER ESSERE UN AGRICOLTORE 4.0",

        "5-2": "ALTRE COMPETENZE PROFESSIONALI PER ESSERE UN AGRICOLTORE 4.0",

        "5-3": "ALTRE COMPETENZE PROFESSIONALI PER ESSERE UN AGRICOLTORE 4.0",

    },

    questions: {

        "0-1-1" : "Selezionare qui livello di Istruzione posseduto.", 

        "0-2-1" : "Qual è il campo in cui sei/vorresti essere un imprenditore in agricoltura? ",

        "1-1-1" : "Ha qualche esperienza precedente in agricoltura come imprenditore?",

        "1-2-1" : "Hai maturato altri tipi di esperienze nel campo agricolo in cui desideri diventare imprenditore?",

        "1-3-1" : "Quali ulteriori esperienze pregresse vanti nel campo dell'agricoltura?",

        "1-4-1" : "Quanto tempo ha trascorso in questa posizione?",

        "1-4-2" : "Quanto tempo è passato da quando ha fatto questa esperienza?",

        "2-1" : "Sono disposto a lavorare regolarmente 50 ore o più a settimana.",

        "2-2" : "La mia famiglia sosterrà il mio desiderio di mettermi in affari La mia famiglia sosterrà il mio desiderio di avviare un'attività.",

        "2-3" : "Sono disposto ad accettare sia i rischi finanziari che quelli legati al lavoro, se necessario.",

        "2-4" : "Non ho bisogno di tutti i fringe benefit forniti da un lavoro regolare (es. contributi pensionistici, ferie pagate).",

        "2-5" : "Sono disposto ad assumermi la piena responsabilità dei successi e/o degli insuccessi della mia attività.",

        "2-6" : "Avrò più successo finanziario avendo la mia attività. La possibilità di successo finanziario è maggiore se ho la mia attività.",

        "2-7" : "Provo un grande orgoglio quando porto a termine un progetto con successo.",

        "2-8" : "Ho un alto livello di energia che può essere mantenuto a lungo.",

        "2-9" : "Mi piace avere il controllo sui miei compiti di lavoro e sulle decisioni che influiscono sul mio lavoro.",

        "2-10" : "Credo di essere responsabile dei miei successi e dei miei fallimenti.",

        "2-11" : "Ho un forte desiderio di ottenere risultati positivi anche se ci vuole un grande sforzo extra.",

        "2-12" : "Ho una buona comprensione di come gestire un business.",

        "2-13" : "Sono in grado di agire in situazioni in cui le cose cambiano rapidamente.",

        "2-14" : "Uno o entrambi i miei genitori erano imprenditori.",

        "2-15" : "Credo di avere capacità e competenze migliori di altri con cui ho lavorato.",

        "2-16" : "Le persone si fidano di me e mi vedono come onesto e affidabile.",

        "2-17" : "Cerco sempre di completare ogni progetto che inizio, non importa quali ostacoli e difficoltà posso incontrare.",

        "2-18" : "Sono disposto a fare qualcosa anche quando gli altri ridono o mi criticano per farlo.",

        "2-19" : "Sono in grado di prendere decisioni rapidamente.",

        "2-20" : "Ho una buona rete di amici, professionisti e conoscenti d'affari.",

        "3-1-1" : "Quando affronto un problema sul lavoro, mi piace trovare diverse possibili soluzioni alternative.",

        "3-1-2": "Se mi si affida un nuovo compito, preferisco seguire attentamente le istruzioni per evitare problemi.",

        "3-1-3": "Quando vedo qualcosa di strano e insolito, preferisco non farmi coinvolgere per evitare inconvenienti.", 

        "3-1-4": "In una discussione, mi piace ascoltare le idee degli altri, anche se non condivido le loro stesse idee.",

        "3-1-5": "Quando le cose non sono chiare, chiedo spiegazioni per capire meglio.",

        "3-1-6": "Quando devo fare un lavoro ripetitivo, di solito cerco modi diversi per finire il compito più velocemente, per farlo in un modo nuovo, o anche per capire se non dovrei farlo perché è inutile.",

        "3-1-7": "Preferisco ragionare con \"logica e razionalità\", evitando di essere emotive e impulsivo.",

        "3-1-8": "Amo le nuove sfide mi motivano a fare del mio meglio.",

        "3-1-9": "Mi piace giocare con le idee.",

        "3-1-10": "Sono d'accordo con l'affermazione \"copiare è utile perché permette l'innovazione\".",

        "3-1-11": "In situazioni complesse, mi rivolgo ad esperti o a coloro che credo siano esperti.",

        "3-1-12": "Sono disposto a combattere per, spiegare e dimostrare il valore della mia idea.",

        "3-1-13": "L'anarchia, in piccole dosi, è un forte strumento di innovazione.",

        "3-1-14": "Inizio i compiti senza completarli completamente.",

        "3-1-15": "È impossibile essere creativi nel lavoro d'ufficio.",

        "3-1-16": "Se cambio lavoro, preferisco un lavoro con compiti di routine o dove so quali compiti devo svolgere.",

        "3-1-17": "Quando ci sono situazioni complicate sul lavoro, cerco di non pensarci troppo. Uso il mio intuito per trovare una soluzione.",

        "3-1-18": "Non credo che gli aspetti manageriali e contabili di un compito siano importanti e concentrerei l'attenzione sulle priorità strategiche.",

        "3-1-19": "Preferisco la fase creativa di un compito perché posso cooperare con gli altri per produrre nuove idee.",

        "3-1-20": "Preferisco le arti/le scienze umane alle scienze naturali/finanziarie.",

        "3-1-21": "Sono aperto al fatto che ci possono essere modi alternativi per raggiungere il risultato desiderato.",

        "3-1-22": "Essere innovativo sul lavoro è un limite. È meglio essere d'accordo con il resto del gruppo.",

        "3-1-23": "Quando scelgo un ristorante o un bar, preferisco quelli che già conosco perché so cosa otterrò.",

        "3-1-24": "Anche quando ci sono situazioni gravi e critiche, mi piace pensare che ci sia una soluzione possibile. Basta cercarla. Non aiuta perdere la speranza.",

        "3-1-25": "Conosco e applico metodi e tecniche per sviluppare la creatività sul lavoro.",

        "3-2-1": "Sono in grado di far colpo sulla persona che parla con me.",

        "3-2-2": "Chi parla di più prevale nella discussione.",

        "3-2-3": "Sò come far accettare le mie idee.",

        "3-2-4": "Mi sento a mio agio nelle discussioni.",

        "3-2-5": "In una discussione c'è sempre un vincitore e un perdente.",

        "3-2-6": "Nel corso di una discussione, non ho paura di mettere in imbarazzo l'altra persona.",

        "3-2-7": "Non ho paura di nessuno.",

        "3-2-8": "Mi piacciono le contraddizioni.",

        "3-2-9": "È necessario sapersi arrabbiare.",

        "3-2-10": "In una discussione voglio vincere.",

        "3-3-1": "Di solito difendo fortemente le mie idee.",

        "3-3-2": "Raramente mi confondo.",

        "3-3-3": "Posso difendere un'idea che non condivido.",

        "3-3-4": "Cerco sempre di capire le intenzioni di un'altra persona.",

        "3-3-5": "Mi sento a mio agio a chiedere la spiegazione di un'idea o a dichiarare che non ho capito un'idea.",

        "3-3-6": "Sono in grado di attirare l'attenzione degli altri e a mantenerla.",

        "3-3-7": "So che sia io che la persona con cui parlo possiamo commettere errori.",

        "3-3-8": "Difendo con forza le mie idee.",

        "3-3-9": "Non cerco i conflitti, ma non ne ho paura.",

        "3-3-10": "Posso cambiare la mia opinione senza sentirmi manipolato.",

        "3-4-1": "Spesso sogno ad occhi aperti.",

        "3-4-2": "Spesso non oso parlare anche se vorrei farlo.",

        "3-4-3": "Preferisco non parlare delle mie idee a certe persone.",

        "3-4-4": "A volte dimentico quello che stavo per dire quando parlo.",

        "3-4-5": "Non mi piace essere coinvolto in un conflitto e cerco di evitarlo.",

        "3-4-6": "Spesso rimango fuori dalla discussione perché non so come difendere le mie idee.",

        "3-4-7": "Mi sento meglio a non far parte della discussione invece di unirmi alla lotta.",

        "3-4-8": "Vorrei essere più in grado di esprimere i miei bisogni con più forza.",

        "3-4-9": "Anche quando mi viene chiesto, è difficile esprimermi in modo chiaro.",

        "3-4-10": "Raramente parlo per primo.",

        "3-5-1": "Evito i conflitti perché non portano a niente.",

        "3-5-2": "Mi piace usare argomenti contrastanti e/o inaspettati.",

        "3-5-3": "È necessario saper scoraggiare chi parla.",

        "3-5-4": "Lascio parlare gli altri per scoprire informazioni su di loro.",

        "3-5-5": "Sono bravo a difendere un punto di vista che non condivido.",

        "3-5-6": "La gente si lascia persuadere più facilmente quando si fa un complimento .",

        "3-5-7": "Parlare per primi è un rischio inutile.",

        "3-5-8": "Causare una discussione tra le altre persone nella discussione è un buon modo per ottenere il controllo di una situazione.",

        "3-5-9": "Sò come nascondere le mie idee quando penso che gli altri non siano d'accordo",

        "3-5-10": "To cause an argument between the other people in the discussion is a good way to gain control of a situation when I think others don't agree with them",

        "4-1-1": "Usare un programma di elaborazione testi, per esempio Word, Pages, Writer, Google Docs, ecc.",

        "4-1-2": "Usare un programma per fogli di calcolo, per esempio Excel, Numbers, Calc, Google Sheets, ecc.",

        "4-1-3": "Usare internet per trovare informazioni.",

        "4-1-4": "Usare gli strumenti di comunicazione e i social media, es. e-mail, Facebook, LinkedIN.",

        "4-2-1": "Sei in grado di lavorare in CAD??",

        "4-2-2": "Sei in grado di lavorare in CAE?",

        "4-2-3": "Sei in grado di lavorare in CAM?",

        "4-2-4": "Sei in grado di lavorare in RE?",

        "4-2-5": "Sei in grado di lavorare nel campo della produzione additiva?",

        "4-2-6": "Sei in grado di utilizzare i social media (es. facebook, Instagram, Pinterest...) o un sito web per presentare te stesso e la tua azienda/attività o vendere i tuoi prodotti?",

        "5-1": "Sai come creare una rete di \"agricoltori digitali\" seguendo le regole del GDPR e come adottare un modello di governance appropriato della tua azienda agricola basato sul concetto di FABLAB, introducendo tecnologie 4.0?",

        "5-2": "Sei esperto nell'internazionalizzazione della tua azienda?",

        "5-3": "Conosci \"l'agricoltura sostenibile\" e la pratichi??",

    },

    answers: {

        "yes": "SI",

        "no": "No",

        "s_agree" : "Fortemente d'accordo",

        "agree": "D'accordo",

        "sw_agree": "Abbastanza d'accordo",

        "disagree" : "In disaccordo",

        "s_disagree": "Fortemente in disaccordo",

        "never": "Mai",

        "rarely": "Raramente",

        "often": "Spesso",

        "always": "Sempre",

        "true": "Vero",

        "false": "Falso",

        "insecure": "Sono insicuro e ho bisogno di aiuto per usare questo tipo di strumento",

        "confident": "Mi sento abbastanza sicuro e di solito trovo le soluzioni da solo quando uso questo strumento",

        "indipendent": "Lavoro in modo indipendente e sicuro e sono in grado di insegnare agli altri come usare questo strumento",

        "dontknow": "Non so",   

        "0-1-1-0": "Licenza elementare",

        "0-1-1-1": "Diploma di scuola media inferiore",

        "0-1-1-2": "Obbligo scolastico - fino ai 16 anni",

        "0-1-1-3": "Diploma professionale - 3 anni",

        "0-1-1-4": "Diploma di scuola media superiore - 5 anni",

        "0-1-1-5": "Diploma corso IFTS o ITS",

        "0-1-1-6": "Diploma di Laurea",

        "0-1-1-7": "Laurea magistrale",

        "0-1-1-8": "Dottorato di Ricerca- PhD",

        "0-2-1-11": "Coltivazione di cereali (tranne il riso), legumi da granella e semi oleosi", 

        "0-2-1-12": "Coltivazione del riso", 

        "0-2-1-13": "Coltivazione di ortaggi e meloni, radici e tuberi",

        "0-2-1-14": "Coltivazione di canna da zucchero", 

        "0-2-1-15": "Coltivazione di tabacco", 

        "0-2-1-16": "Coltivazione di piante tessili", 

        "0-2-1-17": "Coltivazione di altre colture non permanenti", 

        "0-2-1-21": "Coltivazione di uva", 

        "0-2-1-22": "Coltivazione di frutta di origine tropicale e subtropicale", 

        "0-2-1-23": "Coltivazione di agrumi", 

        "0-2-1-24": "Coltivazione di pomacee e frutta a nocciolo", 

        "0-2-1-25": "Coltivazione di altri alberi da frutta, frutti di bosco e in guscio", 

        "0-2-1-26": "Coltivazione di frutti oleosi", 

        "0-2-1-27": "Coltivazione di piante per la produzione di bevande", 

        "0-2-1-28": "Coltivazione di spezie, piante aromatiche e farmaceutiche", 

        "0-2-1-29": "Coltivazione di altre colture permanenti",  

        "0-2-1-30": "Riproduzione delle piante", 

        "0-2-1-41": "Allevamento di bovini da latte", 

        "0-2-1-42": "Allevamento di altri bovini e di bufalini", 

        "0-2-1-43": "Allevamento di cavalli e altri equini", 

        "0-2-1-44": "Allevamento di cammelli e camelidi", 

        "0-2-1-45": "Allevamento di ovini e caprini", 

        "0-2-1-46": "Allevamento di suini", 

        "0-2-1-47": "Allevamento di pollame", 

        "0-2-1-48": "Allevamento di altri animali", 

        "0-2-1-50": "Coltivazioni agricole associate all'allevamento di animali: attività mista", 

        "0-2-1-61": "Attività di supporto alla produzione vegetale", 

        "0-2-1-62": "Attività di supporto alla produzione animale ", 

        "0-2-1-63": "Attività successive alla raccolta ", 

        "0-2-1-64": "Lavorazione delle sementi per la semina", 

        "0-2-1-70": "Caccia, cattura di animali e servizi connessi ", 

        "1-3-1-1" : "esperienza formativa",

        "1-3-1-2" : "lavoro di volontariato",

        "1-3-1-3" : "altre esperienze",

        "1-4-1-1" : "meno di 3 anni",

        "1-4-1-2" : "più di 3 anni",

    },

    results: {

        "1-1": "Anche se puoi già vantare alcune pregresse esperienze in agricoltura in qualità di imprenditore, la nostra piattaforma FARMER 4.0 potrebbe aiutarti ad approfondire alcuni concetti importanti per il tuo successo come Agricoltore 4.0. In ogni caso, qual è la tua propensione all'imprenditorialità e quali sono le tue competenze imprenditoriali?",

        "1-2": "Dato che non hai esperienza come imprenditore in agricoltura, è importante capire prima di tutto la tua propensione all'imprenditorialità e se hai bisogno di acquisire alcune competenze tecniche o soft per avere successo nel campo in cui desideri lavorare. A questo proposito possiamo dire che",

        "1-4": {

            score: {

                "0-1": "Anche se hai fatto altre esperienze (oltre a quelle professionali) in agricoltura, questo tipo di esperienze potrebbero essere non sufficienti (in termini di tempo) o recenti, quindi è importante capire prima di tutto la tua reale propensione all'imprenditorialità e se possiedi il giusto livello di competenze necessarie per avere successo come FARMER 4.0. A questo proposito possiamo dire che",

                "2" : "Anche se hai fatto alcune recenti e importanti esperienze diverse da quelle professionali in agricoltura, non hai affatto esperienza come imprenditore quindi è importante capire prima di tutto la tua reale propensione all'imprenditorialità e se possiedi il giusto livello di competenze necessarie per avere successo come FARMER 4.0. A questo proposito possiamo dire che"

            }

        },

        "2": {

            score: {

            "39": "Probabilmente dovresti evitare la strada dell'imprenditorialità. Ti suggeriamo un colloquio con un consulente orientatore per verificare le tue reali aspettative.",

            "59": "Il lavoro autonomo/imprenditoriale potrebbe non essere una carriera adatta a te. Ti suggeriamo un colloquio con un consulente orientatore per verificare le tue reali aspettative.",

            "79" : "Sembra che lei abbia capacità soddisfacenti per essere un imprenditore.",

            "100": "Sembra che lei abbia capacità eccezionali per essere un imprenditore.",

            }

        },

        "3-1": {

            score: {

            "44": "La creatività è per te irritante. Non vedi alcuna opportunità nella creatività. Eviti le situazioni in cui devi essere creativo. Preferisci lavorare in modo strutturato e logico. Non ti piacciono le situazioni che cambiano molto o il processo di prendere decisioni. Se vuoi avere successo nell'agricoltura 4.0, ti consigliamo di rafforzare la tua creatività (per esempio seguendo un corso su questa soft skill o chiedendo aiuto a un formatore/mentore).",

            "64": "La creatività per te è un dovere. Preferisci un lavoro dove sai quali compiti svolgere e dove raramente devi essere creativo. Tuttavia, quando la situazione lo richiede, sei in grado di trovare soluzioni alternative. Puoi sviluppare la tua creatività essendo più flessibile. Se vuoi avere successo nell'Agricoltura 4.0, ti consigliamo di migliorare la tua creatività (per esempio seguendo un corso su questa soft skill o chiedendo aiuto a un formatore/mentore).",

            "84" : "La creatività per te è necessaria. La creatività non è un problema per te, ma spesso è necessaria. Fare le cose in modo nuovo è un valore e a volte una necessità. Credi che a volte la soluzione debba essere trovata nel \"non conosciuto\". Sei in grado di trovare un equilibrio tra procedure prefissate e l'essere aperto alle alternative. Sei consapevole che devi comunque essere scrupoloso quando fai un lavoro di routine. Questo è un bene per chi vuole avere successo nell'Agricoltura 4.0.",

            "100": "La creatività per te è un piacere. Hai molte idee e sei sempre pronto a trovare nuove ispirazioni, nuove idee e nuovi progetti. Hai bisogno di stare in un ambiente che stimoli la tua creatività e fantasia, altrimenti ti anni e non ti senti abbastanza valorizzato. Ma per favore, fa attenzione: l'intuizione è necessaria, ma non sufficiente! Questo è un bene per chi vuole avere successo nell'Agricoltura 4.0."

            }

        },

        "3-2": {

            score: {

            "2": "Non sei molto determinato (a breve termine) e manchi di coerenza per raggiungere i tuoi obiettivi (a medio e lungo termine). Questo non va bene per chi vuole essere un imprenditore di successo in agricoltura: infatti, una delle caratteristiche più importanti degli imprenditori è la determinazione. Questo tratto è strettamente legato alla fiducia in sé stessi. Più si crede in sé stessi, più è probabile che si continui a lottare per il successo quando ci si trova di fronte a ostacoli che si reputa essere insormontabili. Hai bisogno di determinazione per superare i problemi che assillano ogni nuova impresa. Prendi in considerazione di migliorare la tua capacità di essere determinato e coerente nel raggiungere i tuoi obiettivi (ad esempio, seguendo un corso su queste soft skills o chiedendo aiuto a un trainer/mentore).",

            "5": "Non sei sempre determinato (a breve termine) e occasionalmente potresti non essere coerente quando cerchi di raggiungere i tuoi obiettivi (a medio e lungo termine). Ciò non va bene per chi vuole lavorare come imprenditore di successo in agricoltura: infatti, una delle caratteristiche più importanti degli imprenditori è la determinazione. Questo tratto è strettamente legato alla fiducia in sé stessi. Più si crede in sé stessi, più è probabile che si continui a lottare per il successo quando ci si trova di fronte a ostacoli che si reputa essere insormontabili. Hai bisogno di determinazione per superare i problemi che assillano ogni nuova impresa. Prendi in considerazione di migliorare la tua capacità di essere determinato e coerente nel raggiungere i tuoi obiettivi (ad esempio, seguendo un corso su queste soft skills o chiedendo aiuto a un trainer/mentore).",

            "6" : "Sei molto determinato (a breve termine) e sei molto coerente quando cerchi di raggiungere i tuoi obiettivi (a medio e lungo termine). Questo è eccellente per un imprenditore in agricoltura.",

            "9": "Hai una leggera tendenza a svalutare l'azione di altre persone e a mostrare sentimenti negativi nei confronti della persona che agisce piuttosto che nei confronti dell'azione stessa. Questo non va bene per chi vuole lavorare come imprenditore di successo in agricoltura. Prendi in considerazione di migliorare la tua capacità di essere più collaborativo con gli altri (ad esempio, seguendo un corso su queste soft skills o chiedendo aiuto a un formatore/mentore).",

            "12": "In generale, mostri una tendenza a svalutare l'azione di altre persone e a mostrare sentimenti negativi nei confronti della persona che agisce piuttosto che nei confronti dell'azione stessa. Questo non va bene per chi vuole lavorare come imprenditore di successo in agricoltura. Prendi in considerazione di migliorare la tua capacità di essere più collaborativo con gli altri (ad esempio seguendo un corso su queste soft skills o chiedendo aiuto a un formatore/mentore)",

            }

        },

        "3-3": {

            score: {

            "2": "In generale, mostri una forte tendenza a non sentirti responsabile delle tue azioni: gli imprenditori di successo posseggono un forte senso di responsabilità per il risultato di un'impresa. Per essere un imprenditore, dovresti voler essere un \"vincitore\" responsabile delle tue azioni. Se, invece, ti consideri spesso una \"vittima\" e dai la colpa dei tuoi fallimenti ad altre persone, alla sfortuna o a circostanze difficili, l'imprenditorialità potrebbe non essere la scelta giusta per te. Ti suggeriamo di lavorare su questo aspetto (ad esempio seguendo un corso su queste soft skills o chiedendo aiuto a un trainer/mentore).",

            "5": "In generale, mostri una moderata tendenza a sentirti responsabile delle tue azioni: gli imprenditori di successo posseggono un forte senso di responsabilità per il risultato di un'impresa. Per essere un imprenditore, dovresti voler essere un \"vincitore\" responsabile delle tue azioni. Se, invece, ti consideri spesso una \"vittima\" e dai la colpa dei tuoi fallimenti ad altre persone, alla sfortuna o a circostanze difficili, l'imprenditorialità potrebbe non essere la scelta giusta per te. Ti suggeriamo di lavorare su questo aspetto (ad esempio seguendo un corso su queste soft skills o chiedendo aiuto a un trainer/mentore).",

            "6" : "In generale, mostri una sufficiente tendenza a sentirti responsabile delle tue azioni e quindi una propensione altrettanto sufficiente a impegnarti per raggiungere gli obiettivi: gli imprenditori di successo posseggono un forte senso di responsabilità per il risultato di un'impresa. Per essere un imprenditore, dovresti voler essere un \"vincitore\" responsabile delle tue azioni. Se, invece, ti consideri spesso una \"vittima\" e dai la colpa dei tuoi fallimenti ad altre persone, alla sfortuna o a circostanze difficili, l'imprenditorialità potrebbe non essere la scelta giusta per te. Ti suggeriamo di lavorare su questo aspetto (ad esempio seguendo un corso su queste soft skills o chiedendo aiuto a un trainer/mentore).",

            "9": "Dimostri una buona tendenza a sentirti responsabile e quindi una altrettanto buona propensione ad impegnarti per raggiungere gli obiettivi. Questo è un bene per chi vuole essere un imprenditore di successo in agricoltura.",  

            "12": "Dimostri la tua eccellente tendenza a sentirti responsabile e quindi un'altrettanto eccellente propensione ad impegnarti per raggiungere gli obiettivi. Questo è eccellente per chi vuole essere un imprenditore di successo in agricoltura",  

            }

        },

        "3-4": {

            score: {

            "2": "Si può avere la tendenza a tenere tutto sotto controllo (mancanza di capacità selettiva) e si possono confondere gli obiettivi a breve termine con quelli a lungo termine, il che può portare a essere sopraffatti dalle scadenze. Questa situazione deve essere migliorata (per esempio seguendo un corso su queste soft skills o chiedendo aiuto a un formatore/mentore) perché gli imprenditori sono degli amanti del rischio. Rischiano le loro carriere, il loro tempo e il loro denaro per portare al successo le loro imprese. Per avere successo nel lavoro autonomo, dovresti sentirti a tuo agio nel prendere rischi ragionevoli",

            "5": "Può essere difficile per voi dare priorità agli obiettivi e non siete sempre in grado di distinguere tra questioni molto urgenti e non urgenti. Questo può portare a situazioni molto stressanti. Gli imprenditori sono degli amanti del rischio. Rischiano le loro carriere, il loro tempo e il loro denaro per portare al successo i loro affari. Per avere successo nel lavoro autonomo, dovresti sentirti a tuo agio nel prendere rischi ragionevoli. Questa situazione deve essere migliorata (ad esempio seguendo un corso su queste soft skills o chiedendo aiuto a un formatore/mentore).",

            "6" : "Sei particolarmente abile nel dare priorità agli obiettivi e puoi distinguere tra questioni molto urgenti e non urgenti, come è richiesto a un imprenditore.",

            "9": "Hai difficoltà a completare i tuoi compiti quotidiani e a raggiungere i tuoi obiettivi. Tieni presente che normalmente gli imprenditori hanno un forte bisogno di realizzazione. Si sforzano di eccellere e di realizzare obiettivi che sono piuttosto ambiziosi. Dovresti essere disposto a prefissarti obiettivi ambiziosi e impegnarti con tutte le tue forze per raggiungerli. Per far questo, devi migliorare la tua capacità di portare a termine I tuoi compiti quotidiani e di raggiungere I tuoi obiettivi sapendoti assumere il giusto rischio (per esempio seguendo un corso su queste soft skills o chiedendo aiuto a un trainer/mentore).",

            "12": "Hai difficoltà a completare i tuoi compiti quotidiani e a raggiungere i tuoi obiettivi. Tuttavia, questa situazione può essere migliorata (ad esempio seguendo un corso su queste soft skills o chiedendo aiuto a un formatore/mentore) perché gli imprenditori sono degli amanti del rischio. Rischiano le loro carriere, il loro tempo e il loro denaro per portare al successo le loro imprese. Per avere successo nel lavoro autonomo, dovresti sentirti a tuo agio nell’assumerti rischi ragionevoli.",

            }

        },

        "3-5": {

            score: {

            "2": "Hai una forte tendenza a \"fare da solo\", senza alcun aiuto da parte di altre persone e di agire sulla tua propria leadership/iniziativa/guida. Ma a volte è necessario consultare altri professionisti per consigli, informazioni e riferimenti se si vuole raggiungere il successo. Quindi, ti suggeriamo di migliorare la tua capacità di raggiungere i tuoi obiettivi professionali coinvolgendo altri interlocutori.",

            "5": "Hai una discreta capacità di lavorare di tua iniziativa senza chiedere aiuto ad altri. Ma a volte questo potrebbe non essere sufficiente. Quindi, ti suggeriamo di migliorare la tua capacità di raggiungere i tuoi obiettivi professionali coinvolgendo altri interlocutori",

            "6" : "Sei molto abile a lavorare basandoti solo sulle tue possibilità ma sai anche quando accettare l'aiuto di altre persone e questo è eccellente per chi come te vuole raggiungere obiettivi professionali coinvolgendo altri interlocutori",

            "9": "Mentre hai una discreta capacità ad assegnare compiti, a volte dipendi troppo dall'aiuto degli altri e dalle molte informazioni che devi fornire per sostenere la tua decisione. Quindi ti suggeriamo di migliorare la tua capacità di raggiungere i tuoi obiettivi professionali coinvolgendo altri interlocutori senza arrivare a manipolarli.   Q   ",

            "12": "Mentre sei molto abile nell'assegnare i compiti, tendi a chiedere troppo aiuto e a cercare troppe informazioni per supportare le tue decisioni e questo potrebbe rallentarti. Ti suggeriamo di migliorare la tua capacità di raggiungere i tuoi obiettivi professionali coinvolgendo altri interlocutori senza arrivare a manipolarli.",

            }

        },

        "4-1": {

            score: {

            "5": "Se vuoi essere in grado di utilizzare gli strumenti di FARMER 4.0, devi espandere/ampliare/sviluppare le tue conoscenze informatiche generali seguendo un corso (almeno di livello base).",

            "8": "Se vuoi essere in grado di utilizzare correttamente gli strumenti di FARMER 4.0, potresti migliorare le tue conoscenze seguendo un corso (livello medio).",

            "10" : "Congratulazioni: la tua conoscenza generale delle TIC è avanzata e non dovresti avere alcun problema nell'utilizzare gli strumenti e i modelli di FARMER 4.0",

            }

        },

        

        "4-2-1": {

            "yes":"Anche se sei già in grado di lavorare in CAD, ti invitiamo a dare un'occhiata al modulo CAD/CAM/CAE/RE sulla piattaforma FARMER 4.0",

            "no": "E’ necessario per te seguire il modulo CAD sulla piattaforma FARMER 4.0",

        },

        "4-2-2": {

            "yes": "Anche se sei già in grado di lavorare in CAE, ti invitiamo a dare un'occhiata al modulo CAD/CAM/CAE/RE sulla piattaforma FARMER 4.0",

            "no": "E’ necessario per te seguire il modulo CAE sulla piattaforma FARMER 4.0",

        },

        "4-2-3": {

            "yes": "Anche se sei già in grado di lavorare in CAM, ti invitiamo a dare un'occhiata al modulo CAD/CAM/CAE/RE sulla piattaforma FARMER 4.0",

            "no": "E’ necessario per te seguire il modulo CAM sulla piattaforma FARMER 4.0",

        },

        "4-2-4": {

            "yes": "Anche se sei già in grado di lavorare in RE, ti invitiamo a dare un'occhiata al modulo CAD/CAM/CAE/RE sulla piattaforma FARMER 4.0",

            "no": "E’ necessario per te seguire il modulo RE sulla piattaforma FARMER 4.0",

        },

        "4-2-5": {

            "yes": "Anche se sei già in grado di lavorare nel campo della produzione additiva, ti invitiamo a dare un'occhiata al modulo Additive Manufacturing - Stampa 3D sulla piattaforma FARMER 4.0",

            "no": "È necessario per te seguire il modulo Additive Manufacturing - 3D Print sulla piattaforma FARMER 4.0",

        },

        "4-2-6": {

            "yes": "Anche se sei già in grado di utilizzare i social media (es. facebook, Instagram, Pinterest...) o un sito web per presentare te stesso e la tua azienda/attività o vendere i tuoi prodotti, ti invitiamo a dare un'occhiata ai moduli \"Social Networking per l'azienda agricola globale 4.0\" e \"Strumenti e tecniche di comunicazione on line\" sulla piattaforma FARMER 4.0m.",

            "no": "È necessario per te seguire i moduli \"Social Networking per la Fattoria Globale 4.0\" e \Strumenti e tecniche di comunicazione on line\" sulla piattaforma FARMER 4.0",

        },

        "5-1": {

            "yes": "Anche se sei già in grado di lavorare con un approccio fablab e conosci molto bene la digitalizzazione in agricoltura, ti invitiamo a dare un'occhiata al modulo \"Imprenditoria agricola basata sull'approccio FabLab\" sulla piattaforma FARMER 4.0",

            "no": "È necessario per te seguire il modulo \"Imprenditorialità agricola basata sull'approccio FabLab\" sulla piattaforma FARMER 4.0",

        },

        "5-2": {

            "yes": "Anche se sei già in grado di lavorare in un contesto internazionale, ti invitiamo a dare un'occhiata al modulo \"Internazionalizzazione e sostenibilità dell'azienda agricola globale 4.0\" sulla piattaforma FARMER 4.0",

            "no": "È necessario per te seguire il modulo \"Internazionalizzazione e sostenibilità della Fattoria Globale 4.0\" sulla piattaforma FARMER 4.0",

        },

        "5-3": {

            "yes": "Anche se lavori per la sostenibilità dell'agricoltura, ti invitiamo a dare un'occhiata al modulo \"Internazionalizzazione e sostenibilità della Fattoria Globale 4.0\" sulla piattaforma FARMER 4.0",

            "no": "È necessario per te seguire il modulo \"Internazionalizzazione e sostenibilità della Fattoria Globale 4.0\" sulla piattaforma FARMER 4.0"

        }

    }

}

